import { useRef, useCallback } from 'react';
import { getDimensions, getHeight } from '../utilities.mjs';

function useDimensions() {
  const wrapperRef = useRef(null);
  const childrenRef = useRef(null);
  const comboDimensions = useRef(null);
  const wrapperHeight = useRef(null);
  const childrenHeight = useRef(null);
  const updateDimensions = useCallback(() => {
    comboDimensions.current = getDimensions(wrapperRef.current);
    wrapperHeight.current = comboDimensions.current ? comboDimensions.current.height : null;
    childrenHeight.current = getHeight(childrenRef.current);
  }, []);
  const resetDimensions = useCallback(() => {
    comboDimensions.current = null;
    wrapperHeight.current = null;
    childrenHeight.current = null;
  }, []);
  return [wrapperRef, childrenRef, comboDimensions, wrapperHeight, childrenHeight, updateDimensions, resetDimensions];
}

export { useDimensions };
